if (!customElements.get("card-variants")) {
  customElements.define(
    "card-variants",
    class CardVariants extends HTMLElement {
      constructor() {
        super();

        this.radio = this.querySelectorAll('[type="radio"]');
        this.handleRadioChange = this.onRadioChange.bind(this);

        Array.from(this.radio).forEach((input) =>
          input.addEventListener("change", this.handleRadioChange)
        );
      }

      getVariantMediaWrappers() {
        const cardRoot =
          this.closest(".product-card-wrapper") ||
          this.closest(".card-wrapper") ||
          this.closest(".card") ||
          this.parentNode;
        return cardRoot ? cardRoot.querySelectorAll("[data-variant-alt]") : [];
      }

      /** Map translated option handles to canonical for matching media alt (e.g. Color: Gold) on /it, /fr, /de */
      getCanonicalHandle(handle) {
        if (!handle) return "";
        const h = handle.toLowerCase().replace(/[^a-z0-9-]+/g, "-").replace(/^-|-$/g, "");
        const map = {
          oro: "gold", or: "gold", goud: "gold", "333-gg": "gold",
          argento: "silver", argent: "silver", silber: "silver", sterling: "silver",
          "oro-bianco": "white-gold", "or-blanc": "white-gold", "wit-goud": "white-gold",
          weissgold: "white-gold", "weißgold": "white-gold", "wei-gold": "white-gold",
          "white-gold": "white-gold", whitegold: "white-gold",
          "oro-rosa": "rose-gold", "or-rose": "rose-gold", "rose-goud": "rose-gold",
          rosegold: "rose-gold", "rosé-goud": "rose-gold", "rose-gold": "rose-gold",
          platino: "platinum", "585-gg": "585-gg"
        };
        return map[h] || h;
      }

      onRadioChange(event) {
        if (event.currentTarget.checked) {
          const value = (event.currentTarget.value || "").trim().toLowerCase();
          const valueHandle = value.replace(/[^a-z0-9-]+/g, "-").replace(/^-|-$/g, "");
          const valueId = event.currentTarget.dataset.value;
          const optionValueId = event.currentTarget.dataset.valueId;
          const variantMediaWrappers = this.getVariantMediaWrappers();

          Array.from(variantMediaWrappers).forEach((mediaWrapper) => {
            const variantValueId = mediaWrapper.dataset.variantValueId;
            const variantAlt = mediaWrapper.dataset.variantAlt || "";
            let hide = false;

            if (variantAlt.includes(":")) {
              const parts = variantAlt.split(":");
              const variantValue = (parts[1] || "").trim().toLowerCase();
              const variantHandle = variantValue.replace(/[^a-z0-9-]+/g, "-").replace(/^-|-$/g, "");
              const canonicalSelected = this.getCanonicalHandle(valueHandle);
              const canonicalVariant = this.getCanonicalHandle(variantHandle);
              const matches = canonicalVariant === canonicalSelected || variantHandle === valueHandle;
              hide = !matches;
            } else if (optionValueId != null && variantValueId != null) {
              hide = String(variantValueId) !== String(optionValueId);
            } else if (variantAlt.includes("_") && valueId != null) {
              const parts = variantAlt.split("_").map((s) => (s || "").trim());
              hide = !parts.includes(valueId);
            }

            if (hide) {
              mediaWrapper.style.setProperty("display", "none", "important");
            } else {
              mediaWrapper.style.setProperty("display", "");
            }
          });
        }
      }

      handleizeString(str) {
        if (str) {
          return str.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        }
        return "";
      }
    }
  );
}
